export default "__VITE_ASSET__CpHh9DLA__"